
<script>
    import { game_over, play_ending, num_solved } from './stores.js';
    import { audioData } from './audioData.js';
    import { onMount } from 'svelte';
    
    //number to show the user
    let NumEmailsToShow = 1;
    //total that exists
    let NumEmails = 7;
    //current email being shown
    let EmailID = 1;
    
    export const Emails = {
    1:{
        from: 'Aunt Doris',
        subject: 'More presents from your favorite Aunt',
        body: 'Hey little fish,<br/> &nbsp; &nbsp; I know you\'ve been having a lot of fun with those old computers and electronics I found after your Uncle\'s death. Well, I finally got through all the old boxes, and found one more I thought you\'d like. It seems to be mostly test equipment. I\'ve never seen any of this, so it\'s probably his older stuff when he was younger. The only computer-like thing is a handmade board of some sort. Maybe it makes sense to you. There was also a bunch of random paperwork. I stuck all the electronic looking ones in the package.<br/>        <p/>      I\'m looking forward to seeing you at Christmas when I come down.<p/>      Love, <br/> Your favorite Aunt',
        read: true},
    2:{
        from: 'Aunt Doris',
        subject: 'Strange',
        body: 'Hey, I got some weird texts that were sent as if from Randy! Are you messing with some of the machines again? One of the messages looked like an error code about a broken port. Does that make any sense to you? <br/><br/> Aunt Doris',
        read: false
    },
    3:{
        from: 'Anonymous',
        subject: 'A friend',
        body: 'You need to be careful. If I found you, they will as well. You should stop using the machine. <br/><br/>a friend',
        read: false
    },
    4:{
        from: 'Aunt Doris',
        subject: 'What Happened?',
        body: 'Hey, I got even more weird texts about spies and the government. I\'m freaked out and your phone is now saying it\'s a disconnected number. There\'s a strange car parked outside. I\'m going to sneak out the back. I think you should lay low a while. <br/> Doris',
        read: false
    },
    5:{
        from: 'Mom',
        subject: 'Is everything ok?',
        body: 'Doris just called and said you\'re not answering your phone. She sounded really worried, and said she thought someone was watching her. What happened? Please call me now. I\'m scared.<p/> Mom',
        read: false
    },
    6:{
        from: 'NSA',
        subject: 'Do not be alarmed',
        body: '&nbsp; &nbsp; We believe you are in possession of a rare computer that went missing from a top secret facility in 1984. This machine is dangerous and highly classified. You are not in trouble, but we need the machine back. Do not turn it on! The TIS-100 is more advanced than it seems. We will be there to confiscate the machine immediately.',
        read: false
    },
    7:{
        from: 'Anonymous',
        subject: 'RUN!',
        body: 'Get out! We will contact you later if you make it.',
        read: false
    }
    };
        
    $: (EmailID >= 1)
    {
        Emails[EmailID].read= true;
        //document.getElementById("nextbtn").className = "butnew";
        if(EmailID < NumEmails && $game_over && Emails[EmailID+1].read==true)   
        {
            document.getElementById("nextbtn").className = "butold";
            alert('hey');
        }
    }
    
    onMount(async () => {
            
        if($num_solved >= 10)
            NumEmailsToShow = 2;
        
        if($num_solved >= 15)
            NumEmailsToShow = 3;
        
        if($game_over)
            NumEmailsToShow = NumEmails;
        
	    if($game_over && $play_ending){
            let audioEnding  = new Audio(audioData['ending'].url);
            audioEnding.play();
            play_ending.set(false);
		}
	});
</script>
<style>

.email{
    width:400px;
    background-color:#000;
    margin: auto auto;
}
.email td{
    height: 30px;
    border: 1px solid #fff;
    padding:5px;
}
#main{
    text-align:left;
    width: 450px;
    margin:auto auto;
    font-size:16px;
}
#list{
    font-size:16px;
    text-align:center;
    
}
h2
{
    text-align:center;
}

.dir{
    margin-top:10px;
    width:400px;
    background-color:#000;
    margin: auto auto;
    font-size:20px;
}
.dir button{
    height:40px;
    
    font-size:16px;
    font-family: monospace; 
    font-weight:bold;
}
.butnew{
    background-color:#FFF;
    color:#000;
}
.butold{
    background-color:#000;
    color:#FFF;
}
</style>

<div id="main">
<h3>- E M A I L -</h3>
    <table class="email" align="center" cellpadding="0" cellspacing="0">
        <tr><td style="width:80px;font-weight:bold;">From</td><td>{Emails[EmailID].from}</td></tr>
        <tr><td style="width:80px;font-weight:bold;">Subject</td><td>{Emails[EmailID].subject}</td></tr>
        <!--<tr><td style="width:80px;font-weight:bold;">Attachments</td><td>Manual.pdf, ?</td></tr>-->
        <tr><td colspan="2" style="height:450px" valign="top">
        {@html Emails[EmailID].body}
        </td></tr>
    </table>
    <table class="dir" align="center" cellpadding="0" cellspacing="0">
    <tr><td>
            {#if EmailID > 1} <button on:click="{() =>EmailID = EmailID-1}">&lt; Prev </button>{/if}
        </td><td style="text-align:right;">
            {#if EmailID < NumEmailsToShow}
                <button on:click="{() =>EmailID = EmailID+1}" class="butnew" id="nextbtn">Next &gt;</button>
            {/if}
        </td></tr>
    </table>
    <p/>
    <div id="list">
    <h3>- D O C U M E N T S -</h3>
        Documents found in the package.
        <p/>
        <a href="./manual.pdf">Manual</a>
        <p/>
        <!--<a href="file.pdf">Written Notes</a>-->
    </div>
</div>